module.exports = __webpack_public_path__ + "static/isotype-7d155955eae86682b6b1935693dab2f7.png";